import React, { ReactNode } from 'react';
import { Field, ErrorMessage } from '@atlaskit/form';
import { FormattedMessage, MessageValue } from 'react-intl';
import Textfield from '@atlaskit/textfield';

type ContactDetailFieldProps = {
  fieldName: string;
  fieldLabel: MessageValue | ReactNode;
  value?: string;
  changeHandler: (e: any) => void;
  isRequired?: boolean;
  lengthLimit?: number;
  dataCy?: string;
  width?: number;
  errorMessage?: string;
};

const ContactDetailField = ({
  isRequired,
  fieldName,
  fieldLabel,
  value,
  lengthLimit,
  changeHandler,
  dataCy,
  width,
  errorMessage,
}: ContactDetailFieldProps) => (
  <Field
    aria-required={!!isRequired}
    isRequired={!!isRequired}
    name={fieldName}
    id={fieldName}
    label={fieldLabel as ReactNode}
  >
    {({ fieldProps }) => (
      <>
        <Textfield
          {...fieldProps}
          value={value}
          maxLength={lengthLimit}
          onChange={changeHandler}
          data-cy={dataCy}
          width={width}
        />
        {errorMessage && value && <ErrorMessage>{errorMessage}</ErrorMessage>}
        {isRequired && !value && (
          <ErrorMessage>
            <FormattedMessage
              defaultMessage="This field is required. It can not be empty"
              id="mac.payment-details.billing-form.field-empty"
            />
          </ErrorMessage>
        )}
        {lengthLimit && value && value.length >= lengthLimit && (
          <ErrorMessage>
            <FormattedMessage
              defaultMessage="Max length for {field} is {length}"
              id="mac.payment-details.billing-form.field-length-limit"
              values={{
                field: fieldLabel as MessageValue,
                length: lengthLimit,
              }}
            />
          </ErrorMessage>
        )}
      </>
    )}
  </Field>
);

export default ContactDetailField;
